var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 6.25C23 4.86719 21.8828 3.75 20.5 3.75C19.1172 3.75 18 4.86719 18 6.25V17.5H6.75C5.36719 17.5 4.25 18.6172 4.25 20C4.25 21.3828 5.36719 22.5 6.75 22.5H18V33.75C18 35.1328 19.1172 36.25 20.5 36.25C21.8828 36.25 23 35.1328 23 33.75V22.5H34.25C35.6328 22.5 36.75 21.3828 36.75 20C36.75 18.6172 35.6328 17.5 34.25 17.5H23V6.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.8f85eba332e9410ae1f10863aa14e95c.svg";
export { ForwardRef as ReactComponent };